import {observer} from "mobx-react";
import {product as productStore} from "@/store/Product";
import {price as priceStore} from "@/store/Price";
import {useTranslation} from "react-i18next";
import { formatMoney } from "@/utils/formatMoney";

const ProductPrice = observer(({hasSubscription}) => {
  const {sellingPlanId} = productStore;
  const priceData = priceStore?.currentPrice;
  const subscriptionPrice = priceStore?.pricesQtd1.subscriptionPrice;
  const {t} = useTranslation();

  return (
    <div className="flex flex-col items-end">
      <span className="text-sm font-normal not-italic leading-[140%] tracking-[0.00875rem] md:text-2xl md:leading-[120%] md:tracking-normal">
        {formatMoney(priceData?.price)}
      </span>

      <span className="text-sm font-normal not-italic leading-[140%] tracking-[0.00875rem] line-through decoration-1 opacity-50 md:text-2xl md:leading-[120%] md:tracking-normal">
        {(priceData?.compareAtPrice
          && priceData?.compareAtPrice != priceData.price) ? formatMoney(priceData?.compareAtPrice)
          : " "}
      </span>

      {hasSubscription && (
        <span className="min-w-[50px] text-end text-[0.625rem] font-normal italic leading-[140%] opacity-50 md:min-w-[7.5rem] md:text-[0.75rem]">
          {sellingPlanId
            ? (priceData?.subscriptionLabel ??
              t("product.price_sub_label", {
                money: formatMoney(
                  Math.abs(priceData.compareAtPrice - priceData.price),
                ),
              }))
            : (priceData?.oneTimeLabel ?? (
                <>
                  <span>{t("product.price_otp_label")}</span> <br />
                  <span>
                    {t("product.price_otp2_label", {
                      percentage: parseFloat(
                        (
                          100 -
                          (100 * subscriptionPrice.price) /
                            subscriptionPrice.compareAtPrice
                        ).toFixed(0),
                      ),
                    })}
                  </span>
                </>
              ))}
        </span>
      )}
    </div>
  );
});

export default ProductPrice;
